const $ = jQuery.noConflict();
import Global from '../shared/global';

'use strict';

const ProductTileDocsPopup = {
	/**
	 * @description Cache DOM elements and settings
	 * @type {object}
	 */
	$domBtn: $('.js-docs-popup-init-btn'), // All buttons that trigger the popup
	$domPopup: $('.js-docs-popup'), // All popups
	classActive: 'is-visible', // Class to toggle visibility of the popup

	/** @description Initialize the popup functionality */
	init: function() {
		this.bindEvents(); // Attach event handlers
	},

	/** @description Attach all relevant event listeners */
	bindEvents: function() {
		// Clicking the button toggles the corresponding popup
		this.$domBtn.on('click', this.togglePopup.bind(this));

		// Close all popups when clicking outside of any popup
		Global.clickOutsideContainer(
			Global.$domBody, // The body of the document
			this.$domPopup, // All popup elements
			this.$domBtn, // Buttons that trigger popups
			this.closeAllPopups.bind(this) // Function to close all popups
		);
	},

	/** @description Toggle the visibility of the popup */
	togglePopup: function(e) {
		const btn = $(e.target).closest('.js-docs-popup-init-btn'); // The clicked button
		const popup = btn.siblings('.js-docs-popup'); // The popup associated with the button

		// Close all other popups except the current one
		this.$domPopup.not(popup).removeClass(this.classActive);
		this.$domBtn.not(btn).removeClass('is-active'); // Remove active class from other buttons

		// Toggle the current popup visibility
		popup.toggleClass(this.classActive);

		// Add or remove the active class on the button based on the popup state
		if (popup.hasClass(this.classActive)) {
			btn.addClass('is-active'); // Add active class if popup is visible
		} else {
			btn.removeClass('is-active'); // Remove active class if popup is hidden
		}
	},

	/** @description Close all open popups */
	closeAllPopups: function() {
		this.$domPopup.removeClass(this.classActive); // Remove visibility class from all popups
		this.$domBtn.removeClass('is-active'); // Remove active class from all buttons
	}
};

export default ProductTileDocsPopup;